export enum AuthenticatorType {
  None,
  Google,
  Email,
  Disabled,
}
